import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReportCriteriaItemModel } from '../../models/report-criteria-item.model';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { NgSwitch, NgSwitchCase, NgFor } from '@angular/common';

@Component({
    selector: 'report-criteria-item',
    templateUrl: './report-criteria-item.component.html',
    styleUrls: ['./report-criteria-item.component.css'],
    standalone: true,
    imports: [NgSwitch, ReactiveFormsModule, NgSwitchCase, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, NgFor, MatOption, MatIconButton, MatTooltip, MatIcon]
})
export class ReportCriteriaItemComponent {
  private _criteriaItem: ReportCriteriaItemModel;

  @Input() formGroup: UntypedFormGroup;

  @Input() set criteriaItem(value: ReportCriteriaItemModel) {
    if (!value.formControl) {
      this.setItemFormControls(value);
      this.formGroup.addControl(value.reference, value.formControl);
    }
    this._criteriaItem = value;
  }

  get criteriaItem() {
    return this._criteriaItem;
  }

  constructor() {}

  removeCriterion() {
    this.criteriaItem.used = false;
  }

  private setItemFormControls(criteriaItem: ReportCriteriaItemModel) {
    switch (criteriaItem.type) {
      case 'fromToDate':
        criteriaItem.formControl = new UntypedFormGroup({
          from: new UntypedFormControl(),
          to: new UntypedFormControl()
        });
        break;
      case 'dropDown':
        criteriaItem.formControl = new UntypedFormGroup({
          value: new UntypedFormControl(criteriaItem.defaultValue),
          operator: new UntypedFormControl('=')
        });
        break;
      case 'minMax':
        criteriaItem.formControl = new UntypedFormGroup({
          min: new UntypedFormControl(),
          max: new UntypedFormControl()
        });
        break;
    }
  }
}
